import { createTV } from 'tailwind-variants';

import { twMergeConfig } from './twMerge';

export const tv = createTV({ twMergeConfig });
